"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDarkTheme = exports.unboaredTheme = exports.defaultTheme = exports.unboaredRedTheme = exports.unboaredBlueTheme = exports.unboaredYellowTheme = exports.unboaredGreenTheme = exports.unboaredLightTheme = exports.unboaredDarkTheme = void 0;
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const lightColorTheme = {
    mode: 'light',
    currentPalette: base_ui_theme_colors_1.light,
    backgroundColor: base_ui_theme_colors_1.color.light,
    titleColor: base_ui_theme_colors_1.color.dark,
    textColor: base_ui_theme_colors_1.color.dark,
    secondaryTextColor: base_ui_theme_colors_1.color.dark_secondary,
    tertiaryTextColor: base_ui_theme_colors_1.color.dark_tertiary,
    buttonColor: base_ui_theme_colors_1.color.primary,
    buttonTextColor: base_ui_theme_colors_1.color.dark,
    secondaryButtonColor: (0, base_ui_theme_colors_1.transparency)('light'),
    secondaryButtonTextColor: base_ui_theme_colors_1.color.dark,
    color: base_ui_theme_colors_1.color,
};
const darkColorTheme = {
    /* COLORS */
    mode: 'dark',
    currentPalette: base_ui_theme_colors_1.dark,
    backgroundColor: base_ui_theme_colors_1.color.dark,
    titleColor: base_ui_theme_colors_1.color.light,
    textColor: base_ui_theme_colors_1.color.light,
    secondaryTextColor: base_ui_theme_colors_1.color.light_secondary,
    tertiaryTextColor: base_ui_theme_colors_1.color.light_tertiary,
    buttonColor: base_ui_theme_colors_1.color.primary,
    buttonTextColor: base_ui_theme_colors_1.color.light,
    secondaryButtonColor: (0, base_ui_theme_colors_1.transparency)('dark'),
    secondaryButtonTextColor: base_ui_theme_colors_1.color.light,
    color: base_ui_theme_colors_1.color,
};
const redColorTheme = {
    /* COLORS */
    mode: 'dark',
    currentPalette: base_ui_theme_colors_1.palette.red,
    backgroundColor: base_ui_theme_colors_1.color.dark,
    titleColor: base_ui_theme_colors_1.color.light,
    textColor: base_ui_theme_colors_1.color.light,
    secondaryTextColor: base_ui_theme_colors_1.color.light_secondary,
    tertiaryTextColor: base_ui_theme_colors_1.color.light_tertiary,
    buttonColor: base_ui_theme_colors_1.palette.red.c500,
    buttonTextColor: base_ui_theme_colors_1.color.light,
    secondaryButtonColor: (0, base_ui_theme_colors_1.transparency)('dark'),
    secondaryButtonTextColor: base_ui_theme_colors_1.color.light,
    color: base_ui_theme_colors_1.color,
};
const greenColorTheme = {
    /* COLORS */
    mode: 'dark',
    currentPalette: base_ui_theme_colors_1.palette.green,
    backgroundColor: base_ui_theme_colors_1.color.dark,
    titleColor: base_ui_theme_colors_1.color.light,
    textColor: base_ui_theme_colors_1.color.light,
    secondaryTextColor: base_ui_theme_colors_1.color.light_secondary,
    tertiaryTextColor: base_ui_theme_colors_1.color.light_tertiary,
    buttonColor: base_ui_theme_colors_1.palette.green.c500,
    buttonTextColor: base_ui_theme_colors_1.color.light,
    secondaryButtonColor: (0, base_ui_theme_colors_1.transparency)('dark'),
    secondaryButtonTextColor: base_ui_theme_colors_1.color.light,
    color: base_ui_theme_colors_1.color,
};
const yellowColorTheme = {
    /* COLORS */
    mode: 'dark',
    currentPalette: base_ui_theme_colors_1.palette.yellow,
    backgroundColor: base_ui_theme_colors_1.color.dark,
    titleColor: base_ui_theme_colors_1.color.light,
    textColor: base_ui_theme_colors_1.color.light,
    secondaryTextColor: base_ui_theme_colors_1.color.light_secondary,
    tertiaryTextColor: base_ui_theme_colors_1.color.light_tertiary,
    buttonColor: base_ui_theme_colors_1.palette.yellow.c500,
    buttonTextColor: base_ui_theme_colors_1.color.light,
    secondaryButtonColor: (0, base_ui_theme_colors_1.transparency)('dark'),
    secondaryButtonTextColor: base_ui_theme_colors_1.color.light,
    color: base_ui_theme_colors_1.color,
};
const blueColorTheme = {
    /* COLORS */
    mode: 'dark',
    currentPalette: base_ui_theme_colors_1.palette.blue,
    backgroundColor: base_ui_theme_colors_1.color.dark,
    titleColor: base_ui_theme_colors_1.color.light,
    textColor: base_ui_theme_colors_1.color.light,
    secondaryTextColor: base_ui_theme_colors_1.color.light_secondary,
    tertiaryTextColor: base_ui_theme_colors_1.color.light_tertiary,
    buttonColor: base_ui_theme_colors_1.palette.blue.c500,
    buttonTextColor: base_ui_theme_colors_1.color.light,
    secondaryButtonColor: (0, base_ui_theme_colors_1.transparency)('dark'),
    secondaryButtonTextColor: base_ui_theme_colors_1.color.light,
    color: base_ui_theme_colors_1.color,
};
const unboaredDesignTheme = {
    /* FONTS */
    primaryTitleFont: 'MontserratBold',
    secondaryTitleFont: 'InterBold',
    tertiaryTitleFont: 'InterRegular',
    textFont: 'Inter',
    buttonFont: 'Inter',
    /* TITLE SIZE */
    sizeH1: 22,
    sizeH2: 16,
    sizeH3: 12,
    sizeH4: 12,
    sizeH5: 12,
    sizeP: 10,
    /* BOXES */
    borderRadius: 16,
    boxShadow: 'unset',
};
const unboaredSongTheme = {
    /* SONGS */
    song: {
        main: 'https://raw.githubusercontent.com/unboared/public-assets/master/sounds/Ambiance.mp3',
        move: 'https://raw.githubusercontent.com/unboared/public-assets/master/sounds/Move.mp3',
        validate: 'https://raw.githubusercontent.com/unboared/public-assets/master/sounds/Validate.mp3',
    }
};
exports.unboaredDarkTheme = Object.assign({}, unboaredDesignTheme, darkColorTheme, unboaredSongTheme);
exports.unboaredLightTheme = Object.assign({}, unboaredDesignTheme, lightColorTheme, unboaredSongTheme);
exports.unboaredGreenTheme = Object.assign({}, unboaredDesignTheme, greenColorTheme, unboaredSongTheme);
exports.unboaredYellowTheme = Object.assign({}, unboaredDesignTheme, yellowColorTheme, unboaredSongTheme);
exports.unboaredBlueTheme = Object.assign({}, unboaredDesignTheme, blueColorTheme, unboaredSongTheme);
exports.unboaredRedTheme = Object.assign({}, unboaredDesignTheme, redColorTheme, unboaredSongTheme);
exports.defaultTheme = exports.unboaredLightTheme;
exports.unboaredTheme = {
    default: exports.defaultTheme,
    light: exports.unboaredLightTheme,
    dark: exports.unboaredDarkTheme,
    green: exports.unboaredGreenTheme,
    yellow: exports.unboaredYellowTheme,
    blue: exports.unboaredBlueTheme,
    red: exports.unboaredRedTheme,
};
const isDarkTheme = (theme) => (theme.mode === 'dark');
exports.isDarkTheme = isDarkTheme;
//# sourceMappingURL=themes.js.map